import Field from 'Component/Field';
import Icon from 'Component/Icon';
import { CategorySort as SourceCategorySort } from 'SourceComponent/CategorySort/CategorySort.component';

import './CategorySort.style';

/** @namespace AdvoxBasic/Component/CategorySort/Component/CategorySort */
export class CategorySort extends SourceCategorySort {
    renderSortField() {
        const { sortKey, sortDirection, selectOptions, isMatchingInfoFilter } = this.props;

        if (!isMatchingInfoFilter) {
            return this.renderPlaceholder();
        }

        return (
            <>
                <div block="CategorySort" elem="AdditionalLabel">
                    {__('Sorting:')}
                </div>
                <Field
                    id="category-sort"
                    name="category-sort"
                    type="select"
                    label={__('Sort')}
                    mix={{ block: 'CategorySort', elem: 'Select' }}
                    selectOptions={selectOptions}
                    value={`${sortDirection} ${sortKey}`}
                    onChange={this.onChange}
                />

                <Icon name="small_arrow_down" />
            </>
        );
    }
}

export default CategorySort;
